<template>
  <div v-if="voucherAmount" id="lander_voucher" class="form-row">
    <div class="error pos">You have a voucher for USD {{ voucherAmount }} that will be applied to this trip automatically.</div>
  </div>
  <div v-else-if="isBlocked" id="lander_voucher" class="form-row">
    <div class="error block">This email is NOT linked to a valid voucher. Please use a different email to continue.</div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from "vue";
import useApi from "../utils/apiCalls.js";

const props = defineProps({
  email: String,
  organizationId: Number,
});

const emit = defineEmits(["update:blocked"]);

const { apiGetRequest } = useApi();
const voucher = ref(null);
const isVoucherMandatory = ref(false);
const checked = ref(false);

const voucherAmount = computed(() => {
  const amount = voucher.value?.amount_usd;
  if (amount == null || isNaN(amount) || Number(amount) <= 0) return null;
  return Number(amount).toFixed(2);
});

// Block when the org requires a voucher, the email has been checked, and no voucher was found.
const isBlocked = computed(() => isVoucherMandatory.value && checked.value && !voucher.value);

watch(
  isBlocked,
  blocked => emit("update:blocked", blocked),
  { immediate: true }
);

watch(
  () => [props.email, props.organizationId],
  ([email, orgId]) => {
    if (!email || !orgId || typeof email !== "string" || !email.includes("@")) {
      voucher.value = null;
      isVoucherMandatory.value = false;
      checked.value = false;
      return;
    }

    apiGetRequest({
      path: `/voucher/check?email=${encodeURIComponent(email)}&organization_id=${orgId}`,
      onSuccess: data => {
        voucher.value = data?.voucher || null;
        isVoucherMandatory.value = !!data?.is_voucher_mandatory;
        checked.value = true;
      },
      onError: () => {
        voucher.value = null;
        isVoucherMandatory.value = false;
        checked.value = true;
      },
    });
  },
  { immediate: true }
);
</script>
